import BasicResultModel from "../../domain/model/basic_result_model";
import PaymentRepository from "../../domain/repository/payment_repository";
import { USER_ID_KEY } from "../../../core/constants/app_constants";
import TrackingService from "../service/impl/tracking_service_impl";

const trackingService = new TrackingService();


export default class PaymentRepositoryImpl extends PaymentRepository {
  static #instance = null;

  constructor(paymentApiService, localStorageService, pricingSocketService) {
    if (PaymentRepositoryImpl.#instance) {
      return PaymentRepositoryImpl.#instance;
    }

    super(paymentApiService, localStorageService, pricingSocketService);
    PaymentRepositoryImpl.#instance = this;
  }

  async processSubscriptionPayment(
    tierId,
    { cardHolderFirstName, cardHolderLastName, cardNumber, expiryDate, cvc },
    {
      billingAddressFirstName,
      billingAddressLastName,
      billingAddressEmail,
      billingAddressPhone,
      billingAddressAddressLine1,
      billingAddressCity,
      billingAddressState,
      billingAddressZipCode,
      billingAddressCountry,
    },
    { onSuccess, onError, onDone, onNoBillingAddress, onNoPaymentMethod }
  ) {
    const userId = await this.localStorageService.getData(USER_ID_KEY);

    trackingService.trackEvent("subscription_payment_initiated", { userId: userId, distinct_id: userId, timestamp: new Date().toISOString() });
    this.pricingSocketService.connect({
      onConnected: async (socketId) => {
        const paymentData = {
          metadata: {
            userId,
            objectId: tierId,
            type: "tier",
            socketId,
          },
          // Payment Details
          cust_fname: cardHolderFirstName,
          cust_lname: cardHolderLastName,
          card_number: cardNumber,
          card_expire: expiryDate,
          card_cvv2: cvc,
          // Billing Address
          bill_fname: billingAddressFirstName,
          bill_lname: billingAddressLastName,
          email: billingAddressEmail,
          address1: billingAddressAddressLine1,
          address2: "",
          city: billingAddressCity,
          state: billingAddressState,
          zip: billingAddressZipCode,
          country: billingAddressCountry,
          phone: billingAddressPhone,
        };
        const result = await this.paymentApiService.processSubscriptionPayment(paymentData);
        console.log("SUBSCRIBE TIER RESULT", result);
        if (!result.success) {
          const errorType = result.error[0].type;
          if (errorType == "TIER_NO_BILLING_ADDRESS") {
            onNoBillingAddress();
          } else if (errorType == "TIER_NO_PAYMENT_METHOD") {
            onNoPaymentMethod();
          } else {
            onError(result.message);
          }
          trackingService.trackEvent("subscription_payment_failed", { userId: userId, distinct_id: userId, failure_reason: errorType, timestamp: new Date().toISOString() });
          this.pricingSocketService.disconnect();
        }
      },
      onDisconnected: () => {
        console.log("Disconnected from pricing socket");
        onDone();
      },
      onPaymentEvent: (data) => {
        console.log("Payment event receivedsssss:", data);
        if (data.data.status === "success") {
          onSuccess();
          trackingService.trackEvent("subscription_payment_success", { userId: userId, distinct_id: userId, timestamp: new Date().toISOString() });
          this.pricingSocketService.disconnect();
        } else {
          onError("Failed to subscribe");
          this.pricingSocketService.disconnect();
        }
      },
      onError: (error) => {
        console.log("Error:", error);
        onError(error);
      },
    });
  }

  async processAddonPayment(
    addonId,
    { cardHolderFirstName, cardHolderLastName, cardNumber, expiryDate, cvc },
    {
      billingAddressFirstName,
      billingAddressLastName,
      billingAddressEmail,
      billingAddressPhone,
      billingAddressAddressLine1,
      billingAddressCity,
      billingAddressState,
      billingAddressZipCode,
      billingAddressCountry,
    },
    { onSuccess, onError, onDone, onNoBillingAddress, onNoPaymentMethod }
  ) {
    const userId = await this.localStorageService.getData(USER_ID_KEY);

    trackingService.trackEvent("addon_payment_initiated", { userId: userId, distinct_id: userId, timestamp: new Date().toISOString() });
    this.pricingSocketService.connect({
      onConnected: async (socketId) => {
        const paymentData = {
          metadata: {
            userId,
            objectId: addonId,
            type: "addon",
            socketId,
          },
          // Payment Details
          cust_fname: cardHolderFirstName,
          cust_lname: cardHolderLastName,
          card_number: cardNumber,
          card_expire: expiryDate,
          card_cvv2: cvc,
          // Billing Address
          bill_fname: billingAddressFirstName,
          bill_lname: billingAddressLastName,
          email: billingAddressEmail,
          address1: billingAddressAddressLine1,
          address2: "",
          city: billingAddressCity,
          state: billingAddressState,
          zip: billingAddressZipCode,
          country: billingAddressCountry,
          phone: billingAddressPhone,
        };
        const result = await this.paymentApiService.processSubscriptionPayment(paymentData);
        if (!result.success) {
          const errorType = result.error[0].type;
          if (errorType == "TIER_NO_BILLING_ADDRESS") {
            onNoBillingAddress();
          } else if (errorType == "TIER_NO_PAYMENT_METHOD") {
            onNoPaymentMethod();
          } else {
            onError(result.message);
          }
          trackingService.trackEvent("addon_payment_failed", { userId: userId, distinct_id: userId, failure_reason: errorType, timestamp: new Date().toISOString() });
          this.pricingSocketService.disconnect();
        }
      },
      onDisconnected: () => {
        console.log("Disconnected from pricing socket");
        onDone();
      },
      onPaymentEvent: (data) => {
        console.log("Payment event receivedsssss:", data);
        if (data.data.status === "success") {
          onSuccess();
          trackingService.trackEvent("addon_payment_success", { userId: userId, distinct_id: userId, timestamp: new Date().toISOString() });
          this.pricingSocketService.disconnect();
        } else {
          onError("Failed to subscribe");
          this.pricingSocketService.disconnect();
        }
      },
      onError: (error) => {
        console.log("Error:", error);
        onError(error);
      },
    });
  }
}
